import { create } from 'zustand';

/**
 * Central registry for tracking open panels across all stores.
 *
 * This store reduces the subscription count in useIsAnyPanelOpen from 17 to 1.
 * Each entity store registers/unregisters its panels when they open/close.
 */
interface PanelRegistryState {
  /** Set of currently open panel IDs (e.g., "contact-add", "deal-edit") */
  openPanels: Set<string>;

  /** Computed boolean - true if any panel is open */
  isAnyOpen: boolean;

  /** Register a panel as open */
  registerPanel: (panelId: string) => void;

  /** Unregister a panel (mark as closed) */
  unregisterPanel: (panelId: string) => void;
}

export const usePanelRegistryStore = create<PanelRegistryState>((set) => ({
  openPanels: new Set(),
  isAnyOpen: false,

  registerPanel: (panelId: string) =>
    set((state) => {
      const newSet = new Set(state.openPanels);
      newSet.add(panelId);
      return { openPanels: newSet, isAnyOpen: true };
    }),

  unregisterPanel: (panelId: string) =>
    set((state) => {
      const newSet = new Set(state.openPanels);
      newSet.delete(panelId);
      return { openPanels: newSet, isAnyOpen: newSet.size > 0 };
    }),
}));
